import React, { FC, useEffect, useState } from 'react'
import './EmploymentUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import profileService from 'Services/profileService'
import Swal from 'sweetalert2'

interface propsType {
  toggleModal: () => void
  profile: any
  setProfile: any
}

export type EmploymentUpdate = {
  jobTitle: string
  department: string
  employmentType: string
  manager?: string | null
  workLocation?: string | null
}

const schema = yup.object().shape({
  jobTitle: yup.string().required('Field is required'),
  department: yup.string().required('Field is required'),
  employmentType: yup.string().required('Field is required'),
  //   manager: yup.string().required('Field is required'),
  //   workLocation: yup.string().required('Field is required').max(40, 'Work location cannot exceed 35 characters'),
})

const EmploymentUpdate: FC<propsType> = ({ toggleModal, profile, setProfile }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<EmploymentUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (profile) {
      reset({
        jobTitle: profile.jobTitle,
        department: profile.department,
        employmentType: profile.employmentType,
        manager: profile.manager,
        workLocation: profile.workLocation,
      })
    }
  }, [profile, reset])

  const submitEmployeeDeatils = handleSubmit(
    async (data: EmploymentUpdate, e?: React.BaseSyntheticEvent) => {
      e?.preventDefault()
      setRequest(true)
      await profileService
        .updateProfileV2({
          jobTitle: data.jobTitle,
          department: data.department,
          employmentType: data.employmentType,
          // manager: data.manager,
          // employmentDate: data.employmentDate,
          // workLocation: data.workLocation,
          // lineManagerId: data.lineManagerId,
        })
        .then(
          (res: any) => {
            setRequest(false)
            if (res.data.status === true) {
              Swal.fire({
                text: 'Employment information update request sent succesfully',
                icon: 'success',
                confirmButtonText: 'Ok',
              })
              setProfile((prev: any) => ({
                ...prev,
                ...data,
              }))
            } else {
              const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                  cancelButton: 'btn btn-danger',
                },
                buttonsStyling: false,
              })

              swalWithBootstrapButtons.fire({
                title: 'Oops!',
                text: 'Something went wrong!',
                icon: 'warning',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: 'close',
                reverseButtons: true,
              })
            }

            toggleModal()
          },
          (error: { response: { data: { error: string } } }) => {
            console.log(error)
            setRequest(false)
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                cancelButton: 'btn btn-danger',
              },
              buttonsStyling: false,
            })

            swalWithBootstrapButtons.fire({
              title: 'Oops!',
              text: error.response.data.error,
              icon: 'warning',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'close',
              reverseButtons: true,
            })
          },
        )
      // Here, you would call an API to submit the updated profile data.
    },
  )
  return (
    <div className='employment-update'>
      <form onSubmit={submitEmployeeDeatils}>
        <div className='form-group'>
          <label htmlFor='jobTitle' className=''>
            Job TItle
          </label>
          <input
            autoComplete='off'
            type='text'
            id='job_title'
            className={`form-control ${errors.jobTitle ? 'is-invalid' : ''}`}
            {...register('jobTitle', {
              required: 'Job title is required',
            })}
          />
          {errors.jobTitle && <div className='invalid-feedback'>{errors.jobTitle.message}</div>}
        </div>

        {/* Department */}
        <div className='form-group mt-3'>
          <label htmlFor='department' className=''>
            Department
          </label>

          <select
            autoComplete='off'
            id='department'
            className={`form-control custom-select ${errors.department ? 'is-invalid' : ''}`}
            {...register('department', {
              required: 'Department is required',
            })}
          >
            <option value=''>Select</option>
            <option>Finance Department</option>
            <option>Legal Department</option>
            <option>Corporate Communications Department</option>
            <option>Sales/Marketing Department</option>
            <option>Product Operations Department</option>
            <option>Product Engineering Department</option>
            <option>Human Resources Department</option>
          </select>

          {errors.department && (
            <div className='invalid-feedback d-block'>{errors.department.message}</div>
          )}
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='employmentType' className=''>
              Employment Type
            </label>

            <select
              autoComplete='off'
              id='employmentType'
              className={`form-control ${errors.employmentType ? 'is-invalid' : ''}`}
              {...register('employmentType', {
                required: 'field is required',
              })}
            >
              <option value=''>select</option>
              <option>Full-time</option>
              <option>Part-time</option>
              <option>Contract</option>
            </select>
            {errors.employmentType && (
              <div className='invalid-feedback'>{errors.employmentType.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='manager' className=''>
              Manager / Supervisor
            </label>

            <input
              disabled
              autoComplete='off'
              type='text'
              id='manager'
              className={`form-control custom-select ${errors.manager ? 'is-invalid' : ''}`}
              {...register('manager', {
                required: 'Manager/Supervisor is required',
              })}
            />
            {errors.manager && <div className='invalid-feedback'>{errors.manager.message}</div>}
          </div>
        </div>

        <div className='form-group mt-3'>
          <div className='formLine'>
            <label htmlFor='work_location' className=''>
              Work Location
            </label>

            <input
              autoComplete='off'
              type='text'
              id='work_location'
              className={`form-control custom-select ${errors.workLocation ? 'is-invalid' : ''}`}
              {...register('workLocation')}
              disabled
            />
            {errors.workLocation && (
              <div className='invalid-feedback'>{errors.workLocation.message}</div>
            )}
          </div>
        </div>

        <div className='form-group mt-4'>
          <button
            className='btn btn-default-2 w-100'
            // onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default EmploymentUpdate
